import moment from "moment";


export const format = (date)=>{

    if(Array.isArray(date)){
        return date.map((d)=> moment(d).format('YYYY-MM-DD'))

    }
    return moment(date).format('YYYY-MM-DD')
}

export const toDate = (date)=>{

    if(Array.isArray(date)){
        return date.map((d)=> moment(d).toDate())

    }
    return moment(date).toDate()
}


export const getNextSaturdays = (weeksFromToday = 0) => {
    let thisSaturday = moment(new Date());
    thisSaturday.add(weeksFromToday,'weeks');
    thisSaturday.isoWeekday()
    thisSaturday.day(6 + (moment(new Date()).day() >= 6 ? 7 : 0))

    const nextSaturday = moment(thisSaturday);
    nextSaturday.add(7,'days')
    return [
        thisSaturday.toDate(),
        nextSaturday.toDate()
    ];
}

export const computeDaysBetween = (dateFrom:Date, dateTo:Date, defaultDays:number=1)=>{

    if(!dateFrom || !dateTo){
        return defaultDays
    }

    const df = moment(dateFrom)
    const dt = moment(dateTo)
    const days = dt.diff(df,'days')
    return days
}

export const nextPeriods = (dateFrom:Date, dateTo:Date, numberOfPeriods:Number=1)=>{


    const df = moment(dateFrom)
    const dt = moment(dateTo)
    const days = dt.diff(df,'days')


    let ret = []
    let nextDt = dt.clone()

    for(let i =0; i< numberOfPeriods; i++){
        const pdt = nextDt.clone().add(days,'days')
        const p = {
            'dateFrom': nextDt.toDate(),
            'dateTo': pdt.toDate(),
        }
        nextDt = pdt.clone()
        ret.push(p)
    }

    return ret

}
export const previousPeriods = (dateFrom:Date, dateTo:Date, numberOfPeriods:Number=1)=>{

    const df = moment(dateFrom)
    const dt = moment(dateTo)
    const days = dt.diff(df,'days')

    let ret = []
    let prevDt = df.clone()

    for(let i =0; i< numberOfPeriods; i++){
        const pdf= prevDt.clone().add(-days,'days')
        const p = {
            'dateFrom': pdf.toDate(),
            'dateTo': prevDt.toDate()
        }
        prevDt = pdf.clone()
        ret.push(p)
    }

    return ret

}